export default __webpack_public_path__ + "static/media/RIOTGuide2.0628dfe7.png";